import React, { useState } from 'react';

const UpdateBillerImage = () => {
  const [selectedBiller, setSelectedBiller] = useState('');
  const [image, setImage] = useState(null); // State for the uploaded image
  const [message, setMessage] = useState('');

  const handleBillerChange = (e) => {
    setSelectedBiller(e.target.value);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file)); // Create a URL for the uploaded image
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedBiller !== '' && image) {
      setMessage(`You have selected: ${selectedBiller} and uploaded an image.`);
    } else {
      setMessage('Please select a biller and upload an image.');
    }
  };

  const containerStyle = {
    padding: '20px',
    backgroundColor: '#f4f4f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '500px',
    margin: '0 auto',
    fontSize: '14px',
  };

  const labelStyle = {
    fontWeight: 'bold',
    marginBottom: '8px',
    display: 'block',
  };

  const selectStyle = {
    padding: '8px',
    fontSize: '14px',
    width: '100%',
    borderRadius: '4px',
    border: '1px solid #ccc',
    marginBottom: '20px',
  };

  const buttonStyle = {
    padding: '8px 16px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
  };

  const messageStyle = {
    marginTop: '20px',
    color: 'green',
    fontSize: '14px',
    textAlign: 'center',
  };

  const imagePreviewStyle = {
    marginTop: '20px',
    maxWidth: '100%',
    maxHeight: '200px',
    border: '1px solid #ccc',
    padding: '10px',
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Update Biller Image</h2>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label style={labelStyle}>Select Biller</label>
          <select
            value={selectedBiller}
            onChange={handleBillerChange}
            style={selectStyle}
          >
            <option value="">--Select a Biller--</option>
            <option value="Adhar Housing Finance Limited">Adhar Housing Finance Limited</option>
            <option value="Airtel Mobile Prepaid">Airtel Mobile Prepaid</option>
            <option value="Avas Finance Limited">Avas Finance Limited</option>
          </select>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={labelStyle}>Upload Biller Image</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            style={{ padding: '8px', fontSize: '14px' }}
          />
        </div>

        <button type="submit" style={buttonStyle}>
          Update
        </button>
      </form>

      {message && <div style={messageStyle}>{message}</div>}

      {image && (
        <div style={imagePreviewStyle}>
          <h4>Uploaded Image Preview:</h4>
          <img src={image} alt="Biller" style={{ width: '100%', height: 'auto' }} />
        </div>
      )}
    </div>
  );
};

export default UpdateBillerImage;
